
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"142","height":"43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M141.73 6.16c0-3.4-2.76-6.16-6.16-6.16h-8.22c-3.4 0-6.16 2.76-6.16 6.16 0 3.4 2.76 6.16 6.16 6.16h2.05v24.44c0 3.4 2.76 6.16 6.16 6.16 3.4 0 6.16-2.76 6.16-6.16V6.16h.01s0 .01 0 0zM6.16 12.33a6.16 6.16 0 100-12.32 6.16 6.16 0 000 12.32zM116.62 32.41l-4.36-4.36c2.97-2.97 4.82-7.07 4.82-11.61 0-9.07-7.36-16.43-16.43-16.43-4.54 0-8.64 1.84-11.61 4.81L65.8 28.05l-5.8-5.8 11.72-11.72a6.178 6.178 0 001.8-4.36c0-3.4-2.76-6.16-6.16-6.16-1.7 0-3.24.69-4.36 1.8L51.28 13.53 39.56 1.81A6.178 6.178 0 0035.2.01c-3.4 0-6.16 2.76-6.16 6.16 0 1.7.69 3.24 1.8 4.36l11.72 11.72-5.8 5.8L16.43 7.72c-.67 4.49-4.22 8.04-8.72 8.72L32.4 41.12a6.145 6.145 0 004.36 1.81c1.7 0 3.24-.69 4.36-1.81l10.16-10.16 10.16 10.16a6.145 6.145 0 004.36 1.81c1.7 0 3.24-.69 4.36-1.81l27.59-27.59a4.11 4.11 0 017.01 2.91c0 1.17-.49 2.22-1.27 2.96l-4.29 4.29a6.178 6.178 0 000 8.72l8.71 8.71a6.16 6.16 0 108.71-8.71z","fill":"#2A958D"}})])
          )
        }
      }
    